/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/quiet_hours" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursCacheKeys,
  (
    props: PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursProps
  ): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult> => {
    return fetch(
      `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/timing/quiet_hours`,
      "PUT",
      {
        start_time: props.start_time,
        end_time: props.end_time,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
